import { LineDictionaryModel, LineModel } from '@/lib/models/lines/types';

export const getLineDetails = ({ lineIds, lines }: { lineIds: string[]; lines: LineDictionaryModel }): LineModel[] => {
  return lineIds.map((lineId) => lines[lineId]).filter(Boolean);
};
